import styled from "styled-components";

export default styled.p`
  font-weight: 400;
  margin-block-start: 0;
  margin-block-end: 0;
`;
